import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, Directive } from '@angular/core';
import { CountdownComponent } from './countdown.component';

@Component({
  selector: 'timer',
  providers: [CountdownComponent],
  template: '<countdown [seconds]="timerLength" (progress)="timerProgress($event)" (complete)="onCountComplete()"></countdown>',
  encapsulation: ViewEncapsulation.None
})

export class TimerComponent {
	@Input() timerLength: number;
  @Output() timerPct:EventEmitter<number> = new EventEmitter();
  @Output() timerActive:EventEmitter<boolean> = new EventEmitter();

	//timeout: number;

	onCountComplete(): void{
    this.timerActive.emit(false);
		console.log('Time is up!');
	}

	timerProgress(e):void{
    this.timerPct.emit((this.timerLength - e) / this.timerLength);
    //console.log('timer: ' + e + ' / ' + this.timerLength);
  }

  constructor() {
    //console.log("timer contruct: " + this.timerLength);
  }

  ngOnInit(){
  	//console.log("timer init: " + this.timerLength);
  }
}



// WEBPACK FOOTER //
// ./src/app/game/timer.component.ts